import { EventsUI } from "features";

const Events = () => {
  return (
    <>
      <EventsUI />
    </>
  );
};

export { Events };
